"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportingClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const errors_1 = require("@deliverr/errors");
const client_auth_1 = require("@deliverr/client-auth");
const core_auth_1 = require("@deliverr/core-auth");
const REPORTING_API_URL = process.env.REPORTING_API_URL;
class ReportingClient extends base_client_1.ApiClient {
    constructor(config) {
        const { authEngine } = config;
        const clientConfig = Object.assign(Object.assign({}, config), { baseURL: `${REPORTING_API_URL}/v1/reports`, authEngine: config.authEngine, tokenRefreshFn: authEngine === core_auth_1.AuthEngine.COGNITO_INTERNAL ? new client_auth_1.OAuthClientTokenBuilder(config).getTokenFn() : undefined });
        if (!clientConfig.baseURL) {
            commons_logs_1.log.warn("REPORTING_API_URL environment variable is not set");
        }
        super(clientConfig);
    }
    async generateReport(sellerId, type, dateStart, dateEnd) {
        const body = { type, dateStart, dateEnd };
        try {
            return await this.post(`/async/${sellerId}`, body);
        }
        catch (err) {
            if (!err.response || err.response.status !== 400) {
                throw err;
            }
            else {
                throw new errors_1.DeliverrError("MISSING_PARAMETERS");
            }
        }
    }
    async getReports(sellerId) {
        return this.get(`/${sellerId}`);
    }
    async getReportUrl(sellerId, reportName) {
        return this.get(`/${sellerId}/${reportName}`);
    }
}
exports.ReportingClient = ReportingClient;
//# sourceMappingURL=ReportingClient.js.map